module.exports = __webpack_public_path__ + "static/media/snow.e95bbe2c.svg";